// @ts-ignore
import * as ramda from 'ramda';
import jsCookie from 'js-cookie';
import axios, { AxiosRequestConfig, Method } from 'axios';

import { Modal, message } from 'ant-design-vue';
// import { storage } from '@src/shared/storage';
// import { storage, S_READER_ID } from '@src/lib/storage';

export interface IRequestResult {
	code: number;
	success: boolean;
	message: string;
	data: any;
	ts: number;
}

const axiosInstance = axios.create({
	timeout: 60000,
	withCredentials: true,
});

export const request = async (url: string, option?: AxiosRequestConfig) => {
	const config: any = ramda.mergeAll([
		{
			method: 'get' as Method,
		},
		option,
	]);
	if (config.method.toLocaleLowerCase() === 'get') {
		config.params = ramda.mergeAll([config.params, config.data, {}]);
	}
	const rsp = await axiosInstance(url, config);
	return rsp.data;
};

export const fillApiPrefix = (url: string) => __API_PREFIX__ + (/^\//.test(url) ? url : `/${url}`);
export const getAuthHeaders = () => ({
	['Authorization']: `Bearer ${jsCookie.get("token") || ''}`,
});
const addRequestAuthHeaders = (option: AxiosRequestConfig) => {
	option.headers = option.headers || {};
	const authHeaders = getAuthHeaders();
	option.headers['Authorization'] = option.headers['Authorization'] || authHeaders['Authorization'];
	return option;
};


export const requestApi = async function <RspData>(url: string, option: AxiosRequestConfig) {
	const targetUrl = fillApiPrefix(url);
	try {
		const res = (await request(targetUrl, addRequestAuthHeaders(option))) as IRequestResult;
		if (!res.code) {
			return res as RspData;
		}
		if (res.code === 200) return res.data as RspData;
		if (res.code === 400) {
			message.error(res.data.message);
			return Promise.reject(res);
		}
		message.error(res.message);
		return Promise.reject(res);
	} catch (e: any) {
		apiExceptionHandler({ code: e.code, msg: e.message, url: targetUrl });
		console.error('[requestApi] e >', e);
		return Promise.reject(e);
	}
};

export const requestAuthApi = async function <RspData>(url: string, option: AxiosRequestConfig) {
	try {
		const res = (await request(fillApiPrefix(url), addRequestAuthHeaders(option))) as IRequestResult;
		if (res.success === true) return res.data as RspData;
		return Promise.reject(res);
	} catch (e) {
		return Promise.reject(e);
	}
};



function apiExceptionHandler(options: { code: string; msg: string; url: string }) {
	switch (options.code) {
		case 'BizException': {
			break;
		}
		case 'ERR_NETWORK': {
			Modal.warning({
				title: '网路错误',
				content: '网络连接出现问题，请您检查网络设置!',
				centered: true,
				okText: '知道了',
			});
			break;
		}
		case 'ERR_BAD_RESPONSE': {
			Modal.warning({
				title: '服务错误',
				content: '服务错误，请稍后再试！',
				centered: true,
				okText: '知道了'
				// onOk: () => {
				// 	jsCookie.remove('token', {});
				// 	storage.set('user', undefined)
				// 	window.location.href = `https://www.szlib.org.cn/auth/getOut?domain=${window.location.origin + window.location.pathname}`
				// }
			});
			break;
		}
		case 'ECONNABORTED': {
			Modal.warning({
				title: '接口错误',
				content: options.msg + ` (${options.url})`,
				centered: true,
				okText: '知道了',
			});
			break;
		}
	}
}
